import { render, staticRenderFns } from "./InvoicePaymentDialog.vue?vue&type=template&id=5981d442&"
import script from "./InvoicePaymentDialog.vue?vue&type=script&lang=js&"
export * from "./InvoicePaymentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports